<template>
  <div class="container pt-5">
    <div class="page-wrapper">
      <div class="page-header text-center mb-5">
        <h1 v-if="!loading && !error">
          Couverture des besoins de {{ names }} avec Mes Meilleurs Menus de la semaine
        </h1>

        <h1 v-else>
          Couverture des besoins nutritionnels
        </h1>
      </div>

      <div class="page-content">
        <!-- Loading -->
        <div v-if="loading" class="row">
          <div class="col-12">
            <div class="alert alert-light mb-4">
              Chargement des données...
            </div>
          </div>
        </div>

        <!-- Error -->
        <div v-else-if="error" class="row">
          <div class="col-12">
            <div class="alert alert-danger mb-4">
              {{ error }}
            </div>
          </div>
        </div>

        <!-- Content -->
        <div v-else>
          <h3 class="section-title">Détail des apports caloriques du foyer</h3>

          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-bordered table-striped align-middle custom-table">
                  <tbody>
                    <!-- HEADER GLOBAL (colspan dynamique) -->
                    <tr>
                      <th class="text-center table-title" :colspan="householdEnergy.length + 1">
                        Détail des apports caloriques du foyer
                      </th>
                    </tr>

                    <!-- LIGNE NOMS DES MEMBRES -->
                    <tr>
                      <th>Membre du foyer</th>
                      <td
                        v-for="m in householdEnergy"
                        :key="m.id"
                        class="text-center"
                      >
                        {{ m.name }}
                      </td>
                    </tr>

                    <!-- LIGNE KCAL JOURNALIERS -->
                    <tr>
                      <th>Besoin calorique journalier (en calories)</th>
                      <td
                        v-for="m in householdEnergy"
                        :key="m.id + '-kcal'"
                        class="text-center"
                      >
                        {{ formatNumber(m.kcal) }}
                      </td>
                    </tr>

                    <!-- LIGNE POURCENTAGES -->
                    <tr>
                      <th>En proportion du foyer</th>
                      <td
                        v-for="m in householdEnergy"
                        :key="m.id + '-pct'"
                        class="text-center"
                      >
                        {{ m.percent }}%
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-12">
              <p>
                Sur la base de mon profil nutritionnel et de mon niveau d’activité physique,
                mon besoin calorique moyen est de <strong>{{ formatNumber(dailyEnergyTarget) }} kcal par jour</strong>.
              </p>

              <p>
                <a
                  href="https://mmmenus.fr/mes-apports-nutritionnels"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cliquez ici pour voir la couverture de mes besoins nutritionnels apportée par Mes Meilleurs Menus de la semaine.
                </a>
              </p>

              <p>
                <strong>
                  En complément de Mes Meilleurs Menus, une supplémentation en vitamine D est nécessaire en automne et en hiver,
                  lorsque notre exposition au soleil est insuffisante pour permettre à notre corps de produire suffisamment de vitamine D.
                </strong>
              </p>

              <p>
                Mes Meilleurs Menus sont fournis gratuitement et à titre indicatif. L’Association des Meilleurs Mangeurs ne peut être tenue responsable de l’interprétation ou de l’utilisation des menus.
              </p>
            </div>
          </div>
        </div>
        <!-- /content -->
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";

export default {
  name: "CouvertureBesoins",
  data() {
    return {
      loading: true,
      error: null,

      names: "",
      dailyEnergyTarget: 0,
      householdEnergy: [],
    };
  },
  mounted() {
    api
      .get("couverture-besoins/")
      .then((res) => {
        this.names = res.data.names || "";
        this.dailyEnergyTarget = res.data.daily_energy_target || 0;
        this.householdEnergy = res.data.household_energy || [];
      })
      .catch((e) => {
        const msg =
          (e && e.response && e.response.data && (e.response.data.detail || e.response.data.error)) ||
          (e && e.message) ||
          "Erreur inconnue lors du chargement.";
        this.error = msg;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) return "";
      const n = Number(value);
      if (Number.isNaN(n)) return String(value);
      // Format FR: 6 244
      return new Intl.NumberFormat("fr-FR").format(n);
    },
  },
};
</script>

<style scoped>
.page-header h1 {
  font-family: "TangoSans";
  color: #192704;
}

.section-title {
  font-family: "TangoSans";
  margin-top: 1.2rem;
  font-size: 22px;
  color: #77af24;
}

/* Table un peu plus "propre" */
.custom-table {
  border-radius: 14px;
  overflow: hidden;
}

.table-title {
  font-weight: 700;
}
</style>
